// Adaptador web del notificador del SDK: traduce los avisos que emite la capa
// de datos a toasts de sonner.
//
// Vive acá y no en el SDK a propósito (YGO-261): `packages/ui` ya es web-only
// —depende de Radix y del DOM— así que es el lugar natural para la dependencia
// de sonner. El SDK sólo declara qué avisar; esto decide cómo se ve.
//
// La super-app (Expo) registra su propio notificador con `Alert.alert`.

import { toast } from 'sonner';
import type { Notifier } from '@ygoargentina/sdk/api/notifier';
import { setNotifier } from '@ygoargentina/sdk/api/notifier';

const sonnerNotifier: Notifier = (level, title, options) => {
  const show =
    level === 'success'
      ? toast.success
      : level === 'warning'
        ? toast.warning
        : level === 'error'
          ? toast.error
          : toast.info;

  show(title, options?.description ? { description: options.description } : undefined);
};

/**
 * Conecta los avisos del SDK con sonner. Llamar una vez al arrancar la app,
 * junto con el `<Toaster />`. Sin esto los avisos caen al fallback de consola
 * del SDK.
 */
export const registerSonnerNotifier = (): void => {
  setNotifier(sonnerNotifier);
};
